export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7002890cc644dc6c4f1cf0627d7d65e05699739506&name=pushAdClickData!'